import React, { CSSProperties, useEffect } from 'react';
import {
  Alert as MuiAlert,
  AlertProps as MuiAlertProps,
  Snackbar,
  SnackbarOrigin,
  SxProps,
  Theme,
} from '@mui/material';
import { useLayoutElements } from 'contexts/LayoutElementsContext/useLayoutElements';

export interface AlertProps extends Omit<MuiAlertProps, 'onClose'> {
  isPresented: boolean;
  presentationDuration?: number;
  message: string;
  position?: CSSProperties['position'];
  anchorOrigin?: SnackbarOrigin;
  snackbarSx?: SxProps<Theme>;
  handleDismiss: () => void;
}

export const Alert = ({
  isPresented,
  presentationDuration = 5000,
  message,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' },
  handleDismiss,
  snackbarSx,
  ...muiAlertProps
}: AlertProps) => {
  const { setIsAlertOpen } = useLayoutElements();
  const alertRef = React.useRef<HTMLDivElement>(null);

  // TODO: The open or close state of the alert is managed by parent component
  // If there is a better way to handle this, we can refactor it later
  useEffect(() => {
    setIsAlertOpen(isPresented);
    return () => {
      setIsAlertOpen(false);
    };
  }, [isPresented, setIsAlertOpen]);

  return (
    <Snackbar
      open={isPresented}
      autoHideDuration={presentationDuration}
      onClose={handleDismiss}
      anchorOrigin={anchorOrigin}
      sx={{ position: 'absolute', width: '100%', ...snackbarSx }}
    >
      <MuiAlert ref={alertRef} {...muiAlertProps}>
        {message}
      </MuiAlert>
    </Snackbar>
  );
};
